import React from 'react';

import Webzine from '../board/webzine';

const Visit = props => {
    return (
        <Webzine />
    )
}

export default Visit;


// WEBPACK FOOTER //
// ./src/pages/front/report/resource.js